/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MonitEntityTechAggEntry } from './MonitEntityTechAggEntry';
import {
    MonitEntityTechAggEntryFromJSON,
    MonitEntityTechAggEntryFromJSONTyped,
    MonitEntityTechAggEntryToJSON,
} from './MonitEntityTechAggEntry';

/**
 * 
 * @export
 * @interface MonitPaginatedEntityTechAggResponse
 */
export interface MonitPaginatedEntityTechAggResponse {
    /**
     * 
     * @type {number}
     * @memberof MonitPaginatedEntityTechAggResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitPaginatedEntityTechAggResponse
     */
    page_size?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitPaginatedEntityTechAggResponse
     */
    count?: number;
    /**
     * 
     * @type {Array<MonitEntityTechAggEntry>}
     * @memberof MonitPaginatedEntityTechAggResponse
     */
    results?: Array<MonitEntityTechAggEntry>;
}

/**
 * Check if a given object implements the MonitPaginatedEntityTechAggResponse interface.
 */
export function instanceOfMonitPaginatedEntityTechAggResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitPaginatedEntityTechAggResponseFromJSON(json: any): MonitPaginatedEntityTechAggResponse {
    return MonitPaginatedEntityTechAggResponseFromJSONTyped(json, false);
}

export function MonitPaginatedEntityTechAggResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitPaginatedEntityTechAggResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
        'count': !exists(json, 'count') ? undefined : json['count'],
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(MonitEntityTechAggEntryFromJSON)),
    };
}

export function MonitPaginatedEntityTechAggResponseToJSON(value?: MonitPaginatedEntityTechAggResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'count': value.count,
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(MonitEntityTechAggEntryToJSON)),
    };
}

